import axios from 'axios';
import { removeToken } from '@/managers/token/useCases/removeToken';
import * as Sentry from "@sentry/vue";
import {jwtDecode} from 'jwt-decode';

const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'ngrok-skip-browser-warning': true,
  },
});

const expiredTokensIds = [
  "65d25b633837025bbc86ef4b",
  "65d25b763837025bbc86ef65",
  "65d4bf883ace8a91a7b3de31",
  "65d4bfc53ace8a91a7b3e666",
  "65d4c0953ace8a91a7b3fab8",
  "664ca46d79f8d9e6f5540e6f",
  "664ca4ee79f8d9e6f5542748",
  "664ca63879f8d9e6f554625f",
  "665075e85a1dea9870fed118",
  "665078cd5a1dea9870fee09c",
  "665078df5a1dea9870fee0b6",
  "665078ec5a1dea9870fee0d0",
  "665078fa5a1dea9870fee12c",
  "6650790c5a1dea9870fee2e6",
  "6650791c5a1dea9870fee377",
  "6650792b5a1dea9870fee391",
  "6650793e5a1dea9870fee3cf",
  "66d6e770cdfb14f447f51099",
  "66d6e788cdfb14f447f51240",
  "66d6e793cdfb14f447f51280",
  "66d6e7a2cdfb14f447f512cc",
  "66d6e7bccdfb14f447f5149d",
  "66d6e7d2cdfb14f447f515be",
  "66d6e7dfcdfb14f447f515fa",
  "66d6e7edcdfb14f447f5166f",
  "66d6e7facdfb14f447f5179a",
  "66d6e807cdfb14f447f51812",
  "66d6e811cdfb14f447f51869",
  "66d6e81acdfb14f447f51989",
  "67374d6d873c7dac1a80b82a",
  "67613d5f4364a83bd4aecc53",
  "678520cfae752a2594315011",
  "67c5bbab4ee6b6eb877ffabf",
  "67e2eaba50cbb51191b11759",
  "68010cc17578942766f4ce5b",
];

const setup = (store) => {
  http.interceptors.request.use(
    config => {
      let token = localStorage.getItem('Token');

      if (token) {
        const decodedToken = jwtDecode(token);

        // TODO DELETE AFTER 5 MAY 2025
        const referenceDate = new Date('2025-05-05T12:00:00');
        const referenceTimestamp = referenceDate.getTime(); // Garder en millisecondes

        if (expiredTokensIds.includes(decodedToken.uid) && decodedToken.exp < referenceTimestamp) {
          store.dispatch('token/setIsExpired', true);
          removeToken();
        } else {
          config.headers['Token'] = token;
        }
      }
      config.headers['Source-Application'] = 'crm';

      return config;
    });

  http.interceptors.response.use(
    response => response,
    error => {
      if (error?.response?.status === 500 || error?.response?.status === 503) {
        Sentry.captureException(error, {
          extra: {
            response_body: error.response?.data,
            request_body: error.config?.data,
            url: error.config?.url,
            method: error.config?.method,
          },
          tags: {
            status_code: error.response?.status,
            error_type: 'server_error',
            priority: 'high'
          }
        });
      }

      if (error?.response?.status === 401) {
        store.dispatch('token/setIsExpired', true);
        removeToken();
      } else if (error?.response?.status === 409) {
        let message = error?.response?.data?.message;
        error.message = message;
      }
      return Promise.reject(error);
    },
  );
};

export { http, setup };
